import { styled } from '@mui/material';

import { Box, Skeleton } from '@app-velocity/ui';

const StyledBox = styled(Box)({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'pre-wrap',
  flex: 1,
});

export const WorkspaceSkeleton = () => {
  return (
    <StyledBox>
      <Skeleton width={175} height={25} />
      <Skeleton width={300} height={36} />
      <Skeleton width={170} height={40} />
      <Skeleton width={170} height={40} />
    </StyledBox>
  );
};
